import React, { useState } from "react";
import {
  TextField,
  Button,
  InputAdornment,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import "./auth.css";
import { Link, useNavigate } from "react-router-dom";
import apis from "../../utils/apis";
import httpAction from "../../utils/httpAction";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleClickShowPassword = () => setShowPassword((prev) => !prev);

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is required"),
  });

  const handleSubmit = async (values) => {
    setLoading(true);
    const data = {
      url: apis().login,
      method: "POST",
      body: values,
    };
    const result = await httpAction(data);
    setLoading(false);
    if (result?.status) {
      localStorage.setItem("userId", result?.userId);
      localStorage.setItem("crm-access-token", result?.token);
      navigate("/");
    }
  };

  return (
    <div className="form-container">
      <Formik
        initialValues={{ email: "", password: "" }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors, touched }) => (
          <Form className="form">
            <h2>Login</h2>
            <Field
              name="email"
              as={TextField}
              label="Email"
              fullWidth
              error={touched.email && Boolean(errors.email)}
              helperText={touched.email && errors.email}
            />
            <Field
              name="password"
              as={TextField}
              label="Password"
              type={showPassword ? "text" : "password"}
              fullWidth
              error={touched.password && Boolean(errors.password)}
              helperText={touched.password && errors.password}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleClickShowPassword} edge="end">
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Button
              type="submit"
              variant="contained"
              fullWidth
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : "Login"}
            </Button>
            <div className="footer">
              <Link to="/register">Don't have an account? Register</Link>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Login;
